// extracted by mini-css-extract-plugin
module.exports = {"section":"LearningAssets_section__3psj4","sectionTitle":"LearningAssets_sectionTitle__2eD1H","table":"LearningAssets_table__3ZAtv"};